import React, { useEffect, useState, useRef } from 'react';
import {
    Container,
    Box,
    Avatar,
    Typography,
    Grid,
    TextField,
    Button,
    Paper,
    Chip,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputAdornment,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Snackbar,
} from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import { Grid2 } from '@mui/material';
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';


const PwdTextField = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    return (
        <TextField
            type={showPassword ? 'text' : 'password'}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label={
                                    showPassword ? 'hide the password' : 'display the password'
                                }
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                onMouseUp={handleMouseUpPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}

            {...props}
        />
    )
}


const filter = createFilterOptions();

const EnrollCourse = () => {
    const [selectedCourse, setSelectedCourse] = useState(undefined);
    const [newCourse, setNewCourse] = useState('');
    const [golfPlace, setGolfPlace] = useState([]); //골프장
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();
    const [userId, setUserId] = useState('');
    const [userPw, setUserPw] = useState('');
    const [myCourse, setMyCourse] = useState([]); //골프장

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    const autoCourseNameRef = useRef(null);
    const textCourseNameRef = useRef(null);
    const userIdRef = useRef(null);
    const userPwRef = useRef(null);

    const [stateSnackBar, setStateSnackBar] = React.useState({
        openSnackBar: false,
        verticalSnackBar: 'bottom',
        horizontalSnackBar: 'center',
    });
    const { verticalSnackBar, horizontalSnackBar, openSnackBar } = stateSnackBar;
    const [messageSnackBar, setMessageSnackbar] = useState('');

    const nMaxCount = 3;

    useEffect(() => {
        actions.extendTime(userData);
        getGolfPlace();
        getMyCourse();
    }, [userData]);




    const handleSnackBarClose = () => {
        setStateSnackBar({ ...stateSnackBar, openSnackBar: false });
    };

    const showSnackBar = (msg) => {
        setMessageSnackbar(msg);
        setStateSnackBar({ ...stateSnackBar, openSnackBar: true })
    }



    const PrintOutToServer = (str) => {
            var now = dayjs();
            let timeStr = now.format('YYYY-MM-DD HH:mm:ss:SSS ')
            
            const reqData = {};
            var now = dayjs();
            var nowYear = dayjs(now.format('YYYY'))
            reqData.time = now.format('YYYY-MM-DD HH:mm:ss:SSS')
            reqData.from = userData.userEmail;
            reqData.out = str;
            axios
                .post("/api/booking/PrintOutPut", reqData)
                .then((response) => {
                })
                .catch((err) => {
                    console.error(err);
                });
    }


    const getGolfPlace = async () => {
        console.log('enroll course  getGolfPlace start')
        try {
            let response = await axios.get("/api/booking/GetCourse");
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                console.log("getGolfPlace :" + JSON.stringify(courseData))
                setGolfPlace(courseData);
            }
        } catch (err) {
            console.error(err);

        }
    }


    const getMyCourse = async () => {
        try {
            const reqData = {};
            reqData.userEmail = userData.userEmail;
            reqData.onlyMaked = 0;

            let response = await axios.post("/api/booking/GetMyCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                console.log("getMyCourse :" + JSON.stringify(courseData))
                setMyCourse(courseData);
            }
        } catch (err) {
            console.error(err);

        }
    }


    const renderTextField = (params) => {
        return (
            <TextField {...params} inputRef={autoCourseNameRef} fullWidth label="원하는 골프장을 입력하세요" />
        )
    }

    const findExistCourse = (courseName) => {
        var i = 0;
        for (i = 0; i < golfPlace.length; i++){
            var existName = golfPlace[i].courseName;
            if (existName.indexOf(courseName) > -1) {
                return golfPlace[i];
            }
        }
        return undefined;
    }

    const addCourse = async () => {

        var selCourse = undefined;

        if (!newCourse || newCourse.length < 1) {
            showSnackBar('원하는 골프장을 입력하세요');
            if (autoCourseNameRef.current) {
                autoCourseNameRef.current.focus();
            }
            return;
        }


        if (!userId || userId.length < 1) {
            showSnackBar('골프장 아이디를 입력하세요');
            if (userIdRef.current) {
                userIdRef.current.focus();
            }
            return;
        }

        if (!userPw || userPw.length < 1) {
            showSnackBar('골프장 비밀번호를 입력하세요');
            if (userPwRef.current) {
                userPwRef.current.focus();
            }
            return;
        }

/*
        if (selectedCourse && selectedCourse.courseName == newCourse) {
            selCourse = selectedCourse;
        } else {
            selCourse = findExistCourse(newCourse);
        }
*/


        try {
            const reqData = {};

            reqData.userEmail = userData.userEmail;
            reqData.memberId = userId;
            reqData.memberPw = userPw;

            if (selCourse) {
                reqData.courseName = selCourse.courseName;
                reqData.serial = selCourse.serial;
                reqData.needMakeNew = 0;
                console.log("selCourse : " + JSON.stringify(selCourse));
            } else {
                reqData.inputCourseName = newCourse;
                reqData.needMakeNew = 1;
                console.log("newCourse : " + newCourse);
            }


            let response = await axios.post("/api/booking/AddMyCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                setUserId('');
                setUserPw('');
                setNewCourse('');
                setSelectedCourse(undefined)
                console.log("addCourse :" + JSON.stringify(courseData))
                await getMyCourse();
            } else {
                if (response.data.code === 100) {
                    showSnackBar('이미 등록된 골프장입니다');
                    
                } else {
                    showSnackBar('골프장 등록에 실패하였습니다');
                }
            }
        } catch (err) {
            console.error(err);
            showSnackBar('골프장 등록에 실패하였습니다');

        }



    }


    const delCourse = async (course) => {


        try {
            const reqData = {};

            reqData.userEmail = userData.userEmail;
            reqData.myCourseNum = course.num;


            let response = await axios.post("/api/booking/DelMyCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                await getMyCourse();
            } else {
                showSnackBar('골프장 삭제에 실패하였습니다');
            }
        } catch (err) {
            console.error(err);
            showSnackBar('골프장 삭제에 실패하였습니다');

        }

    }

    const renderMyCourse = (course) => {

        console.log("renderMyCourse :" + JSON.stringify(course))
        
        if (!course ) {
            return null;
        }

        let bgAvatarColor = 'success.main';
        let avatarSize = isMobile ? 24 : 56;
        let btnSize = isMobile ? 'small' : 'midium';
        if (course.needMakeNew  == 1) {
            bgAvatarColor = 'warning.main';
        }

        return (
            <ListItem key={course.num}
                sx={{
                    marginBottom: 3,
                    padding: 0,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        // Add other flexbox properties as needed, e.g., justifyContent, alignItems
                        boxShadow: 3, // Applies an elevation level of 3
                        //                        border: '2px dashed black'
                        padding: { xs: 2, sm: 2, md: 2 },
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            // Add other flexbox properties as needed, e.g., justifyContent, alignItems
                            justifyContent: "space-between"
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: isMobile ? '5px' : '16px', // Example for spacing between items
                                alignItems: "center",
                            }}
                        >
                            <Avatar sx={{ bgcolor: bgAvatarColor, width: avatarSize, height: avatarSize }} aria-label="recipe">
                                G
                            </Avatar>
                            <Typography
                                variant={isMobile ? 'subtitle1' : 'h6'}
                                sx={{
                                    display: 'flex',
                                }}                    >
                                {course.needMakeNew == 0 ? course.courseName : course.inputCourseName}
                            </Typography>

                        </Box>
                        <Stack
                            spacing={1}
                            direction="row"
                            sx={{
                                justifyContent: "flex-end",
                                alignItems: "center",
                            }}

                        >
                            {course.needMakeNew == 1 ? <Chip size={btnSize}  label="신청중..." color="warning" variant="outlined" /> : null}
                            <Button size={btnSize} variant="outlined" onClick={() => delCourse(course)}>삭제</Button>
                        </Stack>
                    </Box>
                    <Stack
                        direction="column"
                        sx={{
                            marginTop:2,
                            justifyContent: "center",
                            alignItems: "center",
                        }}

                    >
                        <Typography variant={isMobile ? 'body2' : 'subtitle1'}>아이디 : {course.memberId}, </Typography>
                        <Typography variant={isMobile ? 'body2' : 'subtitle1'}> 비밀번호 : {course.memberPw}</Typography>
                    </Stack>

                </Box>
            </ListItem>

            
            
        )
    }

    const renderAutoComplete = () => {

        return (

            <Autocomplete
                freeSolo
                disablePortal // Prevents the options list from rendering in a separate portal
                id="combo-box-demo" // Unique ID for the component
                options={golfPlace} // The array of options to display
                getOptionLabel={(option) => {
                    // for example value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    } else {
                        console.log("getOptionLable :" + JSON.stringify(option))
                    }
                    if (option.courseName) {
                        return option.courseName;
                    }
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    return option.courseName;
                }}
                sx={{ marginTop: 3, width: '100%' }} // Styles for the component (e.g., width)
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        console.log('onChange string value : ' + newValue);
                        setSelectedCourse(undefined);
                    } else {
                        if (newValue && newValue.courseName) {
                            console.log('onChange object value 1: ' + JSON.stringify(newValue));
                            setSelectedCourse(newValue);
                        } else {
                            console.log('onChange object value 2: ' + JSON.stringify(newValue));
                            setSelectedCourse(newValue)
                        }
                    }
                }}
                inputValue={newCourse ? newCourse : ''}
                onInputChange={(event, newInputValue) => {
                    console.log('onInputChange : ' + newInputValue);
                    setNewCourse(newInputValue);
                }}
                autoHighlight
                renderInput={(params) => renderTextField(params)} // Renders the input field
            />            
        )
    }


    return (
        <Container maxWidth="md" sx={{ mt: 5, mb:5 }}>
            <Paper elevation={3} sx={{ marginTop: 0, marginBottom:10, padding: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                <Stack
                    direction="column"
                    spacing={0}
                    sx={{
                        width: '100%',
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                    }}

                >
                    <Typography variant="subtitle1">원하시는 골프장 {nMaxCount}개까지 신청가능합니다</Typography>
                    <Typography variant="subtitle1">신청중으로 표시되는 골프장은 신청완료까지 2~3일정도 소요됩니다</Typography>
                    <Typography color="warning" variant="subtitle1">회원제 골프장 신청시 신규개발일 경우 제공하신 아이디와 비밀번호를 개발시 사용하게 됩니다</Typography>
                    <Typography color="warning" variant="subtitle1">사용을 원치않으시면 삭제버튼을 눌러 삭제하시면 됩니다</Typography>

                </Stack>
                
                {/*renderAutoComplete()*/}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="원하는 골프장을 입력하세요"
                    value={newCourse}
                    inputRef={textCourseNameRef}
                    onChange={(e) => setNewCourse(e.target.value)}
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="userId"
                    label="골프장 아이디"
                    name="userId"
                    autoComplete="nickname"
                    value={userId}
                    inputRef={userIdRef} 
                    onChange={(e) => setUserId(e.target.value)}
                />
                <PwdTextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="골프장 비밀번호"
                    id="password"
                    autoComplete="current-password"
                    inputRef={userPwRef} 
                    value={userPw}
                    onChange={(e) => setUserPw(e.target.value)}
                />


                <Button variant="contained" onClick={() => addCourse()}
                    disabled={myCourse.length >= nMaxCount ? true : false}
                >
                    추가
                </Button>
                
                <List sx={{ width: '100%', bgcolor: 'background.paper', marginTop : 5 ,}}>
                    {myCourse.map((course) => renderMyCourse(course))}
                </List>
                
            </Paper>
            <Snackbar
                anchorOrigin={{ vertical: verticalSnackBar, horizontal: horizontalSnackBar }}
                open={openSnackBar}
                onClose={handleSnackBarClose}
                message={messageSnackBar}
                key={verticalSnackBar + horizontalSnackBar}
                autoHideDuration={5000}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={handleSnackBarClose}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            />
        </Container>


                );
}
export default EnrollCourse;